import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { RuleConditionData } from '../../serialization';
import { ConditionRule } from 'lib/reviews/types';
import { RulesConstants } from 'lib/constants/rules';

export const ProductConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.Product.ItemId;

export class ProductCondition<T extends RuleContext> extends WhenCondition<T> {
  product: string;
  constructor(condition: RuleConditionData) {
    super();
    this.product = condition.product as string;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'products.productName',
      comparison: 'array_contains',
      value: this.product,
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
